<template>
  <div style="background: #f6f9fd;">
    <div class="cooperation_wrap">
      <div class="cooperation_tit">{{ $t('company.customers.title') }}</div>
      <div class="cooperation_boxes">
        <div class="cooperation_box" v-for="(img, index) in customerImages" :key="index">
          <img :src="img" class="box_image" alt="客户图片" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerImages: [],
    };
  },
  mounted() {
    // 动态加载图片
    this.customerImages = this.getCustomerImages();
  },
  methods: {
    getCustomerImages() {
      const imageContext = require.context("@/assets/img/customer", false, /\.(png|jpe?g|svg)$/);
      return imageContext.keys().map(imageContext);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 设置全局背景色 */
html, body {
  background: #f6f9fd;
  margin: 0;
  padding: 0;
  height: 100%;
}

.cooperation_wrap {
  width: 50%; /* 只显示中间50% */
  margin: 0 auto; /* 居中对齐 */
  text-align: center;
  padding-bottom: 60px;
  @media screen and (max-width: 768px) {
    width: 90%;
  }
  
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 50px;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .cooperation_boxes {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px;

    .cooperation_box {
      width: calc(20% - 5px); /* 每行5个框，算出每个框占20%的宽度，减去间隔 */
      margin-bottom: 20px;
      background: #fff;
      border: 1px solid #ddd;
      padding: 12px 5px 12px 5px;
      border-radius: 8px;
      display: flex;
      text-align: center;
      justify-content: center;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

      .box_image {
        width: auto;
        height: 40px;
        border-radius: 8px;
        object-fit: cover;
        @media screen and (max-width: 768px) {
          height: 4vw;
        }
      }
    }
  }

  /* 响应式布局：当屏幕宽度小于768px时，每行显示1个 */
  @media screen and (max-width: 768px) {
    .cooperation_box {
      width: calc(100% - 10px); /* 在手机端每个框占满一行 */
    }
  }
}
</style>
